import React from "react";
import L from "leaflet";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const projects = [
  {
    name: "Lagos Operations",
    status: "82% complete",
    summary: "Milestones active, resources assigned, task updates pending.",
    position: [6.5244, 3.3792],
  },
  {
    name: "Abuja Product Team",
    status: "3 milestones due",
    summary: "Sprint tasks, dependencies and milestone progress visible.",
    position: [9.0765, 7.3986],
  },
  {
    name: "Port Harcourt Finance",
    status: "Budget on track",
    summary: "Budget tracking, project reports and time-to-completion insight.",
    position: [4.8156, 7.0498],
  },
];

const createProjectIcon = (label) =>
  L.divIcon({
    className: "pavilion-map__marker",
    html: `<span class="pavilion-map__pulse"></span><span class="pavilion-map__label">${label}</span>`,
    iconSize: [44, 44],
    iconAnchor: [22, 22],
    popupAnchor: [0, -18],
  });

const ProjectMap = () => {
  return (
    <MapContainer
      center={[7.8, 5.6]}
      zoom={6}
      scrollWheelZoom={false}
      preferCanvas
      className="pavilion-map"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        updateWhenIdle
        keepBuffer={1}
        detectRetina={false}
      />
      {projects.map((project, index) => (
        <Marker
          key={project.name}
          position={project.position}
          icon={createProjectIcon(String(index + 1))}
        >
          <Popup>
            <div className="pavilion-map__popup">
              <h6>{project.name}</h6>
              <strong>{project.status}</strong>
              <p>{project.summary}</p>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default ProjectMap;
